import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DriverCommerceStatus, ProductDetail } from '../../driver-commerce-dto';
import { CommerceService } from 'app/services/commerce.service';

@Component({
  selector: 'edit-availed-product-dialog',
  standalone: false,
  templateUrl: './edit-availed-product-dialog.component.html',
  styleUrl: './edit-availed-product-dialog.component.scss'
})
export class EditAvailedProductDialogComponent implements OnInit {

  @Input() visible: boolean = false;
  @Input() product!: ProductDetail;
  @Input() stateIndex: number = 0;
  @Output() hideEditProduct = new EventEmitter<boolean>();
  @Output() showConfirmProduct = new EventEmitter<boolean>();

  constructor(
    private commerceService: CommerceService
  ){}

  public menuItems: any[] = [
    {label: 'Select Status'},
    {label: 'Edit Gadget Details'}
  ];
  public activeIndex: number = 0;
  public selectedStatus: string = '';
  public isFormNotValid: boolean[] = [true, true];

  ngOnInit(): void {
    this.activeIndex = this.stateIndex;
    if(this.activeIndex > 0){
      this.isFormNotValid = [false, false];
    }
  }

  onActiveIndexChange(event: number) {
    this.activeIndex = event;
  }

  nextStep(){
    this.activeIndex = this.activeIndex + 1;
    if(this.activeIndex === 2){
      this.showConfirmProduct.emit(false);
    }
  }

  previousStep(){
    this.activeIndex = this.activeIndex - 1;
  }

  hideDialog(){
    this.commerceService.resetAvailedProductsEdit();
    this.hideEditProduct.emit(false);
  }

  public getStatusText(status: any): string {
      let statusText = '';
      switch (status) {
        case DriverCommerceStatus.PendingTopup:
          statusText = 'Pending Top-up';
          break;
        case DriverCommerceStatus.PendingRelease:
          statusText = 'Pending Release';
          break;
        case DriverCommerceStatus.Active:
          statusText = 'Active';
          break;
        case DriverCommerceStatus.Suspended:
          statusText = 'Suspended';
          break;
        case DriverCommerceStatus.Cancelled:
          statusText = 'Cancelled';
          break;
        case DriverCommerceStatus.Completed:
          statusText = 'Completed';
          break;
        case DriverCommerceStatus.Paused:
          statusText = 'Paused';
          break;
        default:
          statusText = '';
      }
      return statusText;
  }

  isFormInvalid(event: boolean){
    this.isFormNotValid[this.activeIndex] = event;
  }

  getSelectedStatus(event: any){
    this.selectedStatus = event.value;
  }
}
